import BookStructure from './BookStructure';

const OTHER_KEY = 'Other';

const SpecificationQuestionKeys = {
  BOOK_PERSPECTIVE: {
    key: 'bookPerspective',
    answers: [
      'First Person',
      'Second Person',
      'Third Person',
    ],
  },
  INTENDED_READER: {
    key: 'intendedReader',
    answers: [
      'Family, friends & personal network',
      'Business or professional',
      'Academic (scholarly)',
      'Children',
      OTHER_KEY, // custom input field
    ],
  },
  BOOK_STRUCTURE: {
    key: 'bookStructure',
    answers: Object.values(BookStructure),
  },
  OTHER_KEY,
};

export default SpecificationQuestionKeys;
